import React from "react";
import { Image } from "@wss/image";
import { sendSocialClickTrackingEvent } from "~/analytics/socialTracking";
interface SocialIconProps {
  name: string;
  url: string;
  imgSrc: string;
}
const socialLinks: SocialIconProps[] = [{
  name: "Facebook",
  url: "https://www.facebook.com/WebstaurantStore",
  imgSrc: "/uploads/design/2024/3/Blog-Food-Service-Resources-Footer/facebook.png"
}, {
  name: "Pinterest",
  url: "https://www.pinterest.com/webstaurantstore/",
  imgSrc: "/uploads/design/2024/3/Blog-Food-Service-Resources-Footer/pintrest.png"
}, {
  name: "TikTok",
  url: "https://www.tiktok.com/@webstaurantstore?lang=en",
  imgSrc: "/uploads/design/2024/3/Blog-Food-Service-Resources-Footer/tiktok.png"
}, {
  name: "YouTube",
  url: "https://www.youtube.com/user/WebstaurantStore",
  imgSrc: "/uploads/design/2024/3/Blog-Food-Service-Resources-Footer/youtube-upload.png"
}, {
  name: "Instagram",
  url: "https://www.instagram.com/WebstaurantStore/",
  imgSrc: "/uploads/design/2024/3/Blog-Food-Service-Resources-Footer/instagram.png"
}];
const SocialIcon = ({
  name,
  url,
  imgSrc
}: SocialIconProps) => <a href={url} rel="noopener noreferrer" title={`WebstaurantStore ${name}`} target="_blank" aria-label={name} onClick={() => sendSocialClickTrackingEvent(url, name, "Blog")} data-sentry-component="SocialIcon" data-sentry-source-file="BlogFooterSocials.tsx">
    <Image className="h-[50px] w-[50px]" src={imgSrc} alt={`${name} icon`} height={128} width={136} data-sentry-element="Image" data-sentry-source-file="BlogFooterSocials.tsx" />
  </a>;
const BlogFooterSocials = () => {
  return <div className="footer-social-icons border-t border-x-0 border-b-0 border-solid border-gray-200 flex flex-col items-center px-12 py-14" data-sentry-component="BlogFooterSocials" data-sentry-source-file="BlogFooterSocials.tsx">
      <h4 className="p-0 mb-8 font-bold leading-[39.5px] w-56 text-4xl text-center text-gray-800">
        Check us out, we&apos;re social!
      </h4>
      <div className="flex gap-x-4 items-center justify-center">
        {socialLinks.map(link => <SocialIcon key={link.name} {...link} />)}
      </div>
    </div>;
};
export default BlogFooterSocials;